import {
  MILLISECONDS_PER_SECOND,
  MILLISECONDS_PER_MINUTE,
  MILLISECONDS_PER_HOUR,
} from './constants'

function timestampToMs (timestamp: string) : number {
  timestamp = timestamp.trim()
  const [seconds, minutes, hours] = timestamp.split(':').reverse()
  let ms = 0
  if (seconds) ms += parseInt(seconds) * MILLISECONDS_PER_SECOND
  if (minutes) ms += parseInt(minutes) * MILLISECONDS_PER_MINUTE
  if (hours)   ms += parseInt(hours)   * MILLISECONDS_PER_HOUR
  return ms
}

export default timestampToMs
